<div class="text-center my-[50px] bg-[--lightRed] text-white w-fit mx-auto rounded-lg" *ngIf="plan.toLowerCase() === 'free'">
  <div 
  class="bg-red-100 border border-red-400 text-red-700 px-4 py-5 rounded relative text-center max-w-lg mx-auto mt-10">
  <i class='bx bxs-lock text-4xl text-[#D62828] mb-2'></i>
  <p class="font-semibold text-lg">Este conteúdo é exclusivo para assinantes.</p>
  <p class="text-sm mb-4">Assine agora para ter acesso completo às questões e simulações.</p>
  <button class="bg-[#D62828] hover:bg-[#b31f1f] text-white font-bold py-2 px-6 rounded-full text-sm mx-auto"
    [routerLink]="['/my-space/my-plan']">
    Assinar agora
  </button>
</div>
</div>

<main id="questions_container" class="flex flex-col py-5 bg-white" *ngIf="plan.toLowerCase() !== 'free'">
  <!-- Mostrar carregando enquanto 'isLoading' for true -->
  <div *ngIf="isLoading" class="flex justify-center items-center flex-col gap-5 h-[100vh]">
    <div class="spinner animate-spin rounded-full border-4 border-t-4 border-[--lightRed] border-solid w-16 h-16 border-t-transparent shadow-lg"></div>
    <span class="text-[--lightRed]">Carregando...</span>
  </div>

  <!-- Mostrar as perguntas quando 'isLoading' for false -->
  <div *ngIf="!isLoading">
    <app-question *ngFor="let question of questions" [question]="question"></app-question>
  </div>
</main>
